import { GTMQuestSuccess } from '../../../constants/analytics/GTM'
import { useOpen } from '../../useOpen'
import { useModal } from '../../useModal'
import useStateControls from '../../useStateControls'
import { useTranslation } from '../../../translations'
import { COMPLETED_PROFILE, tasksWithInternalLink } from '../../../constants/task'
import { editUserLink } from '../../../constants/copyright'
import { ADD_TO_CART_TYPES, BUY_TYPES, FAVOURITE_TYPES } from '../../../constants/tasksTypes'

export const useClickOnQuestButton = ({ callbacks, taskCallback, quest }) => {
  const { uid, id, type, internal_link, isComplete, button_link } = quest
  const openLink = useOpen()
  const { addModal } = useModal()
  const { setState } = useStateControls()
  const { t } = useTranslation()

  const handleDefault = () => {
    addModal({
      type: 'wordModal',
      props: {
        text: t('task.buttons.answer'),
        isWord: true,
        callback: (word) => callbacks.completeQuest({ id, word }),
      },
    })
  }

  const openInternalLink = () => {
    if (internal_link) {
      setState(internal_link)
    }
  }

  const handleSimple = () => {
    if (tasksWithInternalLink[uid]) {
      return openInternalLink()
    }

    if (uid === COMPLETED_PROFILE) {
      return openLink(editUserLink)
    }

    handleDefault()
  }

  return () => {
    if (!isComplete) {
      if (
        (BUY_TYPES.includes(type) ||
          FAVOURITE_TYPES.includes(type) ||
          ADD_TO_CART_TYPES.includes(type)) &&
        button_link
      ) {
        openLink(button_link)

        return
      }

      const handlers = {
        SignTelegram: () => callbacks.completeQuest({ id }),
        ClickOnLink: () => callbacks.completeQuest({ id }),
        Simple: handleSimple,
        default: openInternalLink,
      }

      ;(handlers[type] ?? handlers.default)?.()
    } else {
      if (type === 'SignCommunication') {
        GTMQuestSuccess()
      }
      callbacks.collectQuest(id)
    }
  }
}
